import type { GetFormCustomisationResponseRow } from '@risksmart-app/drizzle/src/types';

/**
 * Flattens the nested tRPC `getFormCustomisation` response into the flat
 * GraphQL shape `CustomisableFormDataProvider` already consumes: per-table
 * arrays, with `sections_ordering` renamed to `ordering` and only `FieldId`
 * surfaced on nested section fields.
 *
 * Kept in its own file so this pure transform can be unit-tested without
 * pulling in the Apollo-generated query types (which live in a gitignored
 * file generated by `pnpm run generate-graphql`). The return type is
 * inferred so the source rows' typed values (e.g. `FormConfigurationParentType`
 * as the parent-type enum) flow through unchanged and remain assignable to
 * the GraphQL query's typed columns.
 */
export const mapFormCustomisationTrpcToGraphQL = (
  data: GetFormCustomisationResponseRow[]
) => ({
  form_configuration: data,
  form_field_configuration: data.flatMap((c) => c.fields_config ?? []),
  form_field_ordering: data.flatMap((c) => c.fields_ordering ?? []),
  form_section_configuration: data.flatMap((c) =>
    (c.sections_config ?? []).map((s) => ({
      FormConfigurationParentType: s.FormConfigurationParentType,
      SectionId: s.SectionId,
      Label: s.Label,
      Description: s.Description,
      Conditions: s.Conditions,
      fields: (s.fields ?? []).map((f) => ({ FieldId: f.FieldId })),
      ordering: s.sections_ordering ?? null,
    }))
  ),
});
